
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class MFGTransactionDialog extends _Ext.MFGTransDialog<MFGTransactionRow, any> {
        protected getFormKey() { return MFGTransactionForm.formKey; }
        protected getIdProperty() { return MFGTransactionRow.idProperty; }
        protected getLocalTextPrefix() { return MFGTransactionRow.localTextPrefix; }
        protected getNameProperty() { return MFGTransactionRow.nameProperty; }
        protected getService() { return MFGTransactionService.baseUrl; }
        protected getDeletePermission() { return MFGTransactionRow.deletePermission; }
        protected getInsertPermission() { return MFGTransactionRow.insertPermission; }
        protected getUpdatePermission() { return MFGTransactionRow.updatePermission; }
        protected useViewMode() { return true; }

        public form = new MFGTransactionForm(this.idPrefix);
        
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 300;
            q.initMFGItemEditor(this, this.form.ItemDetails, Config);
          
        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            var oldDeleteClick = btnDelete.onClick;
            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };

            //Export PDF Button
            btns.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Invoice',
                cssClass: 'export-pdf-button',
                reportKey: 'Purchase.Approval',
                getParams: () => ({
                    TransID: this.get_entityId()
                })
            }));


            return btns;
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            if (this.hasUpdatePermission) {
                let self = this;
                let Items;
                WIPMovementService.RefList({
                    RefVoucherId: this.entity.VoucherTypeId,
                    RefTransId: this.entity.TransId,
                },
                    response => Items = response.Entities,
                    { async: false }
                );



                if (Items != undefined) {
                    q.Alert("Can not Delete!", "This Voucher has been used in transactions", 2500, false);
                    return;
                    
                } else {
                    Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, false);
                    this.form.ItemDetails.Editable();
                    if (!self.isEditMode())
                        return;
                    self.editClicked = true;

                    self.updateInterface();
                    self.updateTitle();

                }
            }
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let Items:WIPMovementRow[];
            WIPMovementService.RefList({
                RefVoucherId: this.entity.VoucherTypeId,
                RefTransId: this.entity.TransId,
            },
                response => Items = response.Entities,
                { async: false }
            );

            if (Items.length > 0) {
                q.Alert("Can not Delete!", "This Voucher has been used in transactions", 2500, false);
                return;

            } else {

                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        MFGTransactionService.Delete(
                            {
                                EntityId: this.entityId
                            }, response => {
                                Serenity.SubDialogHelper.triggerDataChange(self);
                                self.dialogClose();
                                window.setTimeout(() => //Q.notifySuccess(Q.text('Deleted successfully')), 0);
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Deleted!',
                                        text: 'Voucher Deleted',
                                        showConfirmButton: false,
                                        timer: 1500
                                    })
                                );
                            }
                        );
                    }
                })
            }
        }

    }
}